import * as React from 'react'
import Box from '@mui/material/Box'
import OutlinedInput from '@mui/material/OutlinedInput'
import MenuItem from '@mui/material/MenuItem'
import { MultiSelectProps } from './MultiselectTypes'
import MultiselectStyle from './Style'
import InputFieldStyle from 'components/InputField/Style'
import { Checkbox, ListItemText } from '@mui/material'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      backgroundColor: 'rgba(40, 40, 40, 0.95)',
      color: '#ffffff',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
    },
  },
}

export default function MultiSelect<T extends string>({
  id,
  items,
  selectedItems,
  onChange,
  label,
}: MultiSelectProps<T>): JSX.Element {
  const labelId = `${id}-label`
  const selectId = `${id}-select`
  const inputId = `${id}-input`

  return (
    <>
      {label && (
        <InputFieldStyle.LabelStyle
          sx={{
            color: '#e0e0e0',
            fontSize: '14px',
            fontWeight: 500,
            marginBottom: '8px',
            display: 'block',
          }}
        >
          {label}
        </InputFieldStyle.LabelStyle>
      )}
      <MultiselectStyle.FormControlStyle>
        <MultiselectStyle.SelectStyle
          labelId={labelId}
          id={selectId}
          multiple
          value={selectedItems}
          onChange={(value) => onChange(value.target.value as T[])}
          input={
            <OutlinedInput
              id={inputId}
              label={label}
              sx={{
                color: '#ffffff',
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255, 255, 255, 0.3)',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#1d64f2',
                },
              }}
            />
          }
          renderValue={(items: any) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {items.map((name: any) => (
                <MultiselectStyle.ChipStyle key={name} label={name} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {items.map((label) => {
            return (
              <MenuItem
                key={label}
                value={label}
                sx={{
                  '&:hover': {
                    backgroundColor: 'rgba(29, 100, 242, 0.1)',
                  },
                  '&.Mui-selected': {
                    backgroundColor: 'rgba(29, 100, 242, 0.2)',
                    '&:hover': {
                      backgroundColor: 'rgba(29, 100, 242, 0.3)',
                    },
                  },
                }}
              >
                <Checkbox
                  checked={selectedItems.includes(label)}
                  sx={{
                    color: 'rgba(255, 255, 255, 0.7)',
                    '&.Mui-checked': {
                      color: '#1d64f2',
                    },
                  }}
                />
                <ListItemText
                  primary={label}
                  sx={{
                    color: '#ffffff',
                    '.MuiTypography-root': {
                      fontSize: '14px',
                    },
                  }}
                />
              </MenuItem>
            )
          })}
        </MultiselectStyle.SelectStyle>
      </MultiselectStyle.FormControlStyle>
    </>
  )
}
